// src/App.js
//import DatePicker from 'react-datepicker';
//import 'react-datepicker/dist/react-datepicker.css';
import React, { useState, useEffect } from 'react';
import './App.css'; 
import Navbar from "./NavBar";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { refreshAccessToken, logout } from "./auth";

function App() {
  const [formData, setFormData] = useState({
    SICIL_NO: '',
    IZIN_TUR: '',
    BASLANGIC_TARIH: '',
    BITIS_TARIH: '',
    ACIKLAMA:'',
    YARIM1: false,
    YARIM2: false
  });
  const [izinTurleri, setIzinTurleri] = useState([
    { ID: 1, name: "Doğum İzni" },
    { ID: 2, name: "Mazeret İzni"},
    { ID: 3, name: "Evlilik İzni"},
    { ID: 4, name: "Cenaze İzni"},
    { ID: 5, name: "Yıllık İzin"},
    { ID: 6, name: "İş Kazası"},
    { ID: 7, name: "Mazeretsiz"},
    { ID: 9, name: "Rapor" },
    { ID: 10, name: "Ücretsiz İzin" },
    { ID: 11, name: "Ücretli İzin" },
    { ID: 12, name: "Seyahat Raporu" },
    { ID: 13, name: "Süt İzni" },
    { ID: 14, name: "Görevli" },
    { ID: 15, name: "Babalık İzni" },
    { ID: 16, name: "Doğumgünü İzni" },
    { ID: 17, name: "Taşınma İzni" },
    { ID: 18, name: "Esnek Çalışma İzni" },
    { ID: 19, name: "Öğle Arası İzni" },
    { ID: 20, name: "Eğitim İzni" },
    { ID: 21, name: "Askerlik İzni" },
    { ID: 22, name: "Refakat İzni" },
    { ID: 23, name: "Uzaktan Çalışma İzni" }
  ]);
  
  const [izinler, setIzinler] = useState([]); 
  const [leaveReport, setLeaveReport] = useState([]);
  const [loadingLeaveReport, setLoadingLeaveReport] = useState([]);
  const [user, setuser]=useState(null);// = location.state?.user||JSON.parse(localStorage.getItem("user"));
  const [loading, setLoading]=useState(true);
  const [error, setError] = useState("");
  const fetchIzinler = async (user) => {
    
    if (!user) {
        console.error("SICIL bilgisi lokalde bulunamadı");
        return;
    }else {
      console.log("user verified");
    }

    try {
        const response = await fetch(`/izin_talep/${user.SICIL_NO}`);

        if (!response.ok) { console.log(response); throw new Error("Veriler alınamadı!");}
        

        const data = await response.json();
        setIzinler(data);
        setLoading(false);
    } catch (error) {
        console.error("Hata:", error);
    }
};


useEffect(() => {
  async function init() {
    const success = await refreshAccessToken();
    if (!success) {
      console.log('Refresh failed, redirected to login.');
      return;
    }
    console.log("izin_talep useeffect");
    try {
      const res = await fetch('/me', { credentials: 'include' });
      const data = await res.json();
      if (res.ok) {
        if (data.sicil_no) {
          //console.log("data:" , data);
          setFormData((prevData) => ({ ...prevData, SICIL_NO: data.sicil_no }));
          setuser(data);
          fetchLeaveReport(data.sicil_no);
          fetchIzinler(data);
        } else {
          console.error("Sicil bilgisi bulunamadı");
          alert("Kullanıcı bilgilerinin yeniden girilmesi gerekiyor.");
        logout();
        }
      } else {
        console.error("User fetch error:", data.error);
        alert("Kullanıcı bilgilerinin yeniden girilmesi gerekiyor.");
        logout();
      }
    } catch (err) {
      console.error("User fetch exception:", err);
      alert("Kullanıcı bilgilerinin yeniden girilmesi gerekiyor.");
      logout();
    }
  }

  init();
}, []);
  
const countValidDays = (startDate, endDate, yarim1, yarim2) => {
      let count = 0;
      const date1 = new Date(startDate);
      date1.setHours(0,0,0,0);
      const date2 = new Date(endDate);
      date2.setHours(0,0,0,0);
      while (date1 <= date2) {
        const day = date1.getDay(); // 0 = Sunday
        if (day !== 0) count++;
        date1.setDate(date1.getDate() + 1);
      }
      if(yarim1) count = count - 0.5;
      if(yarim2) count = count - 0.5;
      console.log("countvaliddays:",count);
      return count;
    };
  const validateIzinForm = (formData) => {
    const izinTurID = parseInt(formData.IZIN_TUR);
    const start = new Date(formData.BASLANGIC_TARIH);
    const end = new Date(formData.BITIS_TARIH);
    const yarim1 = formData.YARIM1;
    const yarim2 = formData.YARIM2;
  
    if (isNaN(izinTurID) || !formData.BASLANGIC_TARIH || !formData.BITIS_TARIH) {
      return { valid: false, message: "Lütfen izin türünü ve tarihleri seçin." };
    }
  
    if (end < start) {
      return { valid: false, message: "Bitiş tarihi başlangıç tarihinden önce olamaz." };
    }
  if (formData.YARIM1 && formData.YARIM2 && start.getTime()===end.getTime()) {
      return { valid: false, message: "Tek günlük izinlerde hem başlangıç hem bitiş yarım gün olamaz." };
    }
    // Count days excluding Sundays (and optionally Saturdays for specific cases)
    
  const gun = countValidDays(start, end, yarim1,yarim2);
    // --- İzin kuralları ---
    if(gun<=0)
      return { valid: false, message: "İzin aralığı geçersiz. Kontrol ediniz." };
    if (izinTurID === 1) { // Doğum İzni
      
      if (gun > 96) {//Pazarlar sayılmıyor (16 hafta * 6)
        return { valid: false, message: "Doğum izni en fazla 16 hafta olabilir." };
      }
    }
    
    if (izinTurID === 3) { // Evlilik İzni
      
      if (gun > 3) {
        return { valid: false, message: "Evlilik izni en fazla 3 gün olabilir." };
      }
    }
    if (izinTurID === 4) { // Cenaze İzni
     
      if (gun > 3) {
        return { valid: false, message: "Cenaze izni en fazla 3 gün olabilir." };
      }
    }
    if (izinTurID === 15) { // Babalık İzni
      
      if (gun > 5) {
        return { valid: false, message: "Babalık izni en fazla 5 gün olabilir." };
      }
    }
    if (izinTurID === 16) { // Doğum günü İzni
      
      if (gun > 1) {
        return { valid: false, message: "Doğum günü izni en fazla 1 gün olabilir." };
      }
    }
    if (izinTurID === 17) { // Taşınma İzni
      
      if (gun > 1) {
        return { valid: false, message: "Taşınma izni en fazla 1 gün olabilir." };
      }
    }
    // Kurallar bitti...
  console.log("Count valid days:",gun);
    return { valid: true }; // sorun yok
  };
  

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    if(!user)
    {
      alert("Kullanıcı bilgisine ulaşılamıyor. Yeniden giriş yapınız.");
      setLoading(false);
      return;
    }
    //console.log("Submitting with formData:", formData);
    
    const validation = validateIzinForm(formData);
    if (!validation.valid) {
      alert(validation.message);
      setLoading(false);
      return;
    }
    const selected_izin_data= izinTurleri.find((tur) => tur.ID === Number(formData.IZIN_TUR));
    const IZIN_TUR_AD = selected_izin_data?.name||"-";
  
    const payload = {...formData, SICIL_NO:user.sicil_no,IZIN_TUR_AD};
    const response = await fetch(`/izin_talep`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
    });

    //console.log('Response status:', response.status);
    if (response.ok) {
      alert('İzin talep kaydı gönderildi');
      //const user = location.state?.user||JSON.parse(localStorage.getItem("user"));
      //sendLeaveNotification(user.SICIL_NO, user.ADI_SOYADI,formData.IZIN_TUR,formData.BASLANGIC_TARIH,formData.BITIS_TARIH );
    setFormData({
      
      SICIL_NO: user.SICIL_NO,
      IZIN_TUR: '',
      BASLANGIC_TARIH: '',
      BITIS_TARIH: '',
      ACIKLAMA:'',
      YARIM1: false,
      YARIM2: false
    });
    fetchLeaveReport(user.SICIL_NO);
    fetchIzinler(user); 
    setLoading(false);
    } else {
      const errorData = await response.json();
      //console.log('Error response:', errorData);  
      alert(`Hata: ${errorData.error || 'Kayıt hatası'}`);
      setLoading(false);
    }
    setFormData({
      
      SICIL_NO: user.SICIL_NO,
      IZIN_TUR: '',
      BASLANGIC_TARIH: '',
      BITIS_TARIH: '',
      ACIKLAMA:'',
      YARIM1: false,
      YARIM2: false
    });
  };

  const handleDelete = async (id) => {
    
    if(!user)
    {
      alert("Kullanıcı bilgisine ulaşılamıyor. Yeniden giriş yapınız.");
      return;
    }

    const confirm = window.confirm("Bu izin talebinizi silmek istediğinize emin misiniz?");
    if (!confirm) return;
    setLoading(true);
    try {
      //const response = await fetch(`/izin_talep/${id}`, {
      //  method: "DELETE",
      const response = await fetch(`/izin_sil/${id}`, {
        method: "POST",
      });
  
      if (response.ok) {
        window.alert("Kayıt silindi.");
        fetchIzinler(user); // Refresh the list
      } else {
        const error = await response.json();
        window.alert(`Hata: ${error.message || "Silme işlemi başarısız."}`);
      }
    } catch (err) {
      console.error("Silme hatası:", err);
      window.alert("Sunucu hatası oluştu.");
    }
  };
const fetchLeaveReport = async (sicilNo) => {
    //("fetchLeaveReport:", sicilNo);
    setLoadingLeaveReport(true);
    try {
      //console.log("fetchLeaveReport - inside try");
      const response = await fetch(`/izin_rapor/${sicilNo}`);
      if (!response.ok) {
        const text = await response.text();
        throw new Error(text || "İzin kayıtları alınamadı");
      }
      const data = await response.json();
      //console.log("fetchLeaveReport response:",data);
      setLeaveReport(data);
    } catch (err) {
      setError(err.message);
    }finally{setLoadingLeaveReport(false);}
    
  };
///////////////////////////////////////////

  return (
    <div>
   
      <div className="container">
         <Navbar />
      {/* Header */}
      <h2>İzin Kullanım Özetiniz</h2>
          {loadingLeaveReport?(<p>Rapor yükleniyor... Bekleyiniz...</p>):(leaveReport.length > 0 ? (
            
            <table className="report-table">
              <thead>
                <tr>

                  <th>İzin Türü</th>
                  <th>Kullanılan</th>
                  <th>Kalan Hak</th>
                </tr>
              </thead>
              <tbody>
                {leaveReport.map((item, index) => (
                  <tr key={index}>
                    
                    <td>{item.ACIKLAMA}</td>
                    <td>{(item.TOPLAM_GUN)??"-"}</td>
                    <td>{item.KALAN??"-"}</td>
                  </tr>
                ))}
              </tbody>
            </table>
            
          ) : (
            <p>Kayıtlı izin bulunamadı.</p>
          ))}
      <h1>İzin Talep Formu</h1>
        <form onSubmit={handleSubmit}>
          <label htmlFor="sicil_no">Sicil No</label>
          <input
            id="sicil_no"
            type="text"
            value={formData.SICIL_NO}
            readOnly 
            onChange={(e) => setFormData({ ...formData, SICIL_NO: user.SICIL_NO })}
          />
          
          <label htmlFor="izin_tur">İzin Tür</label>
          <select
          id="izin_tur"
          value={formData.IZIN_TUR}
          onChange={(e) => setFormData({ ...formData, IZIN_TUR: e.target.value })}
          >
          <option value="">Seçiniz</option>
          {izinTurleri.map((tur) => (
            <option key={tur.ID} value={tur.ID}>
              {tur.name}
            </option>
          ))}
        </select>
          
          <label htmlFor="baslangic_tarih">Başlangıç Tarihi</label>
          <input
            id="baslangic_tarih"
            type="date"
            value={formData.BASLANGIC_TARIH}
            onChange={(e) => setFormData({ ...formData, BASLANGIC_TARIH: e.target.value })}
          />
          <label style={{display:'inline-flex', marginBottom: '0.8rem', alignItems:'center', gap:'12px', whiteSpace: 'nowrap'}} >Yarım gün
            <input type="checkbox" checked={formData.YARIM1} onChange={(e) => setFormData({ ...formData, YARIM1: e.target.checked })} style ={{transform: 'scale(1)', cursor: 'pointer'}} />
          </label>

          <label htmlFor="bitis_tarih">Bitiş Tarihi</label>
          <input
            id="bitis_tarih"
            type="date"
            value={formData.BITIS_TARIH}
            onChange={(e) => setFormData({ ...formData, BITIS_TARIH: e.target.value })}
          />
          <label style={{display:'inline-flex', marginBottom: '0.8rem', alignItems:'center', gap:'12px', whiteSpace: 'nowrap'}} >Yarım gün
            <input type="checkbox" checked={formData.YARIM2} onChange={(e) => setFormData({ ...formData, YARIM2: e.target.checked })} style ={{transform: 'scale(1)',margin: '0',padding:'0', cursor: 'pointer'}}/>
          </label>

          <label htmlFor="aciklama">Açıklama</label>
          <textarea
            id="aciklama"
            value={formData.ACIKLAMA}
            onChange={(e) => setFormData({ ...formData, ACIKLAMA: e.target.value })}
            rows="4"
            placeholder=""
          ></textarea>
          <button disabled={loading} type="submit">Gönder</button>
        </form>

        <h2>İzin Listesi</h2>
        <div className="table_wrapper">
        <table>
  <thead>
    <tr>


      <th>İzin Tür</th>
      <th>Başlangıç</th>
      <th>Bitiş</th>
      <th>Açıklama/Gerekçe</th>
      <th>Gün</th>
      <th>Onay</th>
      <th>Sil</th> {/* new column */}
    </tr>
  </thead>
  <tbody>
    {izinler.map((izin) => {
      const izinTur = izinTurleri.find((tur) => tur.ID === izin.IZIN_TUR);
      return (
        <tr key={izin.ID}>


          <td>{izinTur ? izinTur.name : 'Belirtilmedi'}</td>
          <td>{new Date(izin.BASLANGIC_TARIH).toLocaleString('tr-TR')}</td>
          <td>{new Date(izin.BITIS_TARIH).toLocaleString('tr-TR')}</td>
          <td>{izin.ACIKLAMA}</td>
          <td>{izin.TALEP_GUN}</td>
          <td>{izin.ONAY === true ? '✔️' : izin.ONAY === false ? '❌' : '⏳'}</td>
          <td>{izin.ONAY === null && (<button onClick={() => handleDelete(izin.ID)}>🗑️</button>)}</td>
        </tr>
      );
    })}
  </tbody>
</table>
</div>

      </div>
      </div>
    
  );
}



export default App;
